import { render, staticRenderFns } from "./IntegralConfigEdit.vue?vue&type=template&id=48299f97&scoped=true"
import script from "./IntegralConfigEdit.vue?vue&type=script&lang=js"
export * from "./IntegralConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./IntegralConfigEdit.vue?vue&type=style&index=0&id=48299f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48299f97",
  null
  
)

export default component.exports